import SelectVender from "@/src/views/integrations/whatsapp/SelectVender.vue";
import AddCredentials from "@/src/views/integrations/whatsapp/AddCredentials.vue";
import ConfirmDetails from "@/src/views/integrations/whatsapp/ConfirmDetails.vue";

export const whatsappHeaders = [
    { label: "Vendor", key: "vendor_type", width: 200 },
    { label: "Phone Number", key: "phone_number", width: 200 },
    { label: "Connected Status", key: "status", width: 200 },
    { label: "Created At", key: "created_at", width: 200 },
];

export const connectWhatsappSteps = {
    SELECT_VENDER: "SELECT_VENDER",
    ADD_CREDENTIALS: "ADD_CREDENTIALS",
    CONFIRM_DETAILS: "CONFIRM_DETAILS",
  };
  
  export const stepLabels = {
    [connectWhatsappSteps.SELECT_VENDER]: "Select Vendor",
    [connectWhatsappSteps.ADD_CREDENTIALS]: "Add Credentials",
    [connectWhatsappSteps.CONFIRM_DETAILS]: "Confirm Details",
  };
  
  export const stepComponents = {
    [connectWhatsappSteps.SELECT_VENDER]: SelectVender,
    [connectWhatsappSteps.ADD_CREDENTIALS]: AddCredentials,
    [connectWhatsappSteps.CONFIRM_DETAILS]: ConfirmDetails,
  };

export const TEMPLATE_STATUS = {
  APPROVED: "APPROVED",
  PENDING: "PENDING",
  REJECTED: "REJECTED",
};

export const TEMPLATE_STATUS_LIST = [
  TEMPLATE_STATUS.APPROVED,
  TEMPLATE_STATUS.PENDING,
  TEMPLATE_STATUS.REJECTED,
];

export const TEMPLATE_COMPONENT_TYPE = {
  HEADER: "HEADER",
  BODY: "BODY",
  FOOTER: "FOOTER",
  BUTTONS: "BUTTONS",
  CAROUSEL: "CAROUSEL",
};

export const HEADER_FORMAT = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  DOCUMENT: "DOCUMENT",
};

export const BUTTON_TYPE = {
  NONE: "NONE",
  QUICK_REPLY: "QUICK_REPLY",
  URL: "URL",
  PHONE_NUMBER: "PHONE_NUMBER",
  COPY_CODE: "COPY_CODE",
  VISIT_WEBSITE: "VISIT_WEBSITE",
  CALL: "CALL",
};

export const TEMPLATE_FORMAT = {
  CUSTOM: "CUSTOM",
  CAROUSEL: "CAROUSEL",
};

export const whatsappTemplateComponentTypes = TEMPLATE_COMPONENT_TYPE;
export const whatsappMediaFormats = HEADER_FORMAT;

export const campaignChannels = {
  WHATSAPP: "WHATSAPP",
  EMAIL: "EMAIL",
};

export const campaignRouteNames = {
  WHATSAPP: "create_whatsapp_campaign_v2",
  EMAIL: "create_email_campaign",
};

export const TEMPLATE_NOTE_TEMPLATE_NAME_ALLOWED =
  "(Note: Only lowercase alphanumeric and underscores are allowed. Eg: order_confirmation)";

export const CAROUSEL_NOTE_ALL_CARDS_MEDIA_FORMAT =
  "(Note: All cards will use this media format)";

export const CAROUSEL_NOTE_CONFIGURE_BUTTON_TYPES =
  "(Note: Configure which button types will appear on all cards)";

export const CAROUSEL_NOTE_UPLOAD_SAMPLE_IMAGE =
  "(Note: Upload one sample image that will be used as preview for all cards)";

export const CAROUSEL_NOTE_UPLOAD_SAMPLE_VIDEO =
  "(Note: Upload one sample video that will be used as preview for all cards)";

export const CAROUSEL_NOTE_IMAGE_SIZE =
  "(Note: Image size must be less than 5 MB)";

export const CAROUSEL_NOTE_VIDEO_SIZE =
  "(Note: Video size must be less than 16 MB)";
